import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask w-full h-full"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-container-week-model",
  ref: "target"
}
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "flex-col h-full" }
const _hoisted_6 = { class: "modal-content-scroll" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "row w-full" }
const _hoisted_9 = { class: "col w-full" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "row pad-m" }
const _hoisted_12 = { class: "col-0-6 align-r mright-08" }
const _hoisted_13 = { styles: "main-m font-m" }
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = { class: "row gap-06" }

import { ref, watch, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { CreateWeekModelRequest, DayModelLightResponse, PersonLightResponse, SettingsApi, WeekModelByNameResponse, WeekModelIdsRequest, WeekModelResponse, WeekModelUpdateNameRequest } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { ApiError, ItemSelect } from '@/models/share.model';
import { useAppUserStore } from '@/stores/appUser';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import Select from 'primevue/select';
import InputText from 'primevue/inputtext';


export default /*@__PURE__*/_defineComponent({
  __name: 'esWeekModelSettings',
  props: {
    selectedInstituteId: {},
    refreshData: { type: Boolean },
    selectedHealthPro: {},
    header: {},
    isOpen: { type: Boolean }
  },
  emits: ['week-model-changed', 'modal-close'],
  setup(__props: any, { emit: __emit }) {

const settingsApi = new SettingsApi(medServerApiConfig);

const props = __props;

const { t } = useI18n();
const toast = useToast();
const appUserStore = useAppUserStore();

const weekModelByNames = ref<WeekModelByNameResponse[]>([])
const dayModels = ref<ItemSelect[]>([]);
const activeIndex = ref<number[]>([]);

const indexToUpdate = ref<number>(undefined);
const weekModelUpdateNameRequest = ref<WeekModelUpdateNameRequest>(undefined);

const emits = __emit;

const currentPersonId = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personWithRoleId
});


const findWeekModelByInstitute = async () => {
  if (props.selectedInstituteId && (currentPersonId.value || props.selectedHealthPro?.id)) {
     await settingsApi.findWeekModelByInstitute({instituteId: props.selectedInstituteId, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value})
      .then((result: WeekModelByNameResponse[]) => {
        weekModelByNames.value = result;
      }).catch((error: ApiError) => {
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });
      });
  }
}

const transformToItemSelect = (dataToTransform: DayModelLightResponse): ItemSelect => {
    if (dataToTransform) {
      return {
        id: dataToTransform.dayModelId,
        label: dataToTransform.name
      }
    }
}

const findDayModelByInstitute = async () => {
  if (props.selectedInstituteId && (currentPersonId.value || props.selectedHealthPro?.id)) {
    const daysModelList: DayModelLightResponse[] =  await settingsApi.findDayModelByInstitute({instituteId: props.selectedInstituteId, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value});
    dayModels.value = daysModelList.map((dayModel: DayModelLightResponse) => transformToItemSelect(dayModel));
  }
}

const isChanged = (dayModel: ItemSelect, weekModel: WeekModelResponse) => {
  return weekModel.dayModel?.dayModelId !== dayModel.id;
}

const changeDayModel = async (dayModel: ItemSelect, weekModel: WeekModelResponse) => {
    if (dayModel && dayModel.id && weekModel && isChanged(dayModel, weekModel) && props.selectedInstituteId) {
      settingsApi.updateWeekModel({
        instituteId: props.selectedInstituteId,
        weekmodelId: weekModel.weekModelId,
        weekModelRequest: {
          dayModelId: dayModel?.id ?? null
        }
      }).then(() => {
        toastSuccess(toast, {
            summary: t('common.toast.success.update'),
            detail:  t('settings.label.weekModel.message.success.update')
        });
        findWeekModelByInstitute();
        emits('week-model-changed');
      }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t(`error.${error.status}`)
        });
      });
    }
}

const refreshData = async() => {
  indexToUpdate.value = undefined;
  weekModelUpdateNameRequest.value = {
    newName: undefined,
    weekModelIds: undefined
  };

  await findWeekModelByInstitute();
  await findDayModelByInstitute();
}

const confirmFormModal = () => {
  emits('modal-close')
}

const addWeekType = () => {
  if (props.selectedInstituteId && (props.selectedHealthPro || currentPersonId.value)) {
    const createWeekModelRequest: CreateWeekModelRequest = {
      name: t('settings.label.weekModel.nameOfNew')
    }
    settingsApi.addWeekModelByInstitute({instituteId:  props.selectedInstituteId, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value, createWeekModelRequest: createWeekModelRequest})
      .then((result: WeekModelByNameResponse[]) => {
        weekModelByNames.value = result;
        refreshData();
      }).catch((error: ApiError) => {
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });
      });
  }
}

const openUdateWeekModelName = (currentName: string, weekmodels: WeekModelResponse[], index: number) => {
  indexToUpdate.value = index;
  weekModelUpdateNameRequest.value.newName = currentName;
  weekModelUpdateNameRequest.value.weekModelIds = weekmodels.map((weekModel) => weekModel.weekModelId);
  activeIndex.value = [];
};

const closeUdateWeekModelName = () => {
  indexToUpdate.value = undefined;
  weekModelUpdateNameRequest.value = {
    newName: undefined,
    weekModelIds: undefined
  };
};

const validUpdateWeekModelName = () => {
  if (props.selectedInstituteId && (props.selectedHealthPro || currentPersonId.value)) {
    settingsApi.updateWeekModelsName({instituteId:  props.selectedInstituteId, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value, weekModelUpdateNameRequest: weekModelUpdateNameRequest.value})
      .then(() => {
        toastSuccess(toast, {
            summary: t('common.toast.success.update'),
            detail:  t('settings.label.weekModel.message.success.update')
        });
        refreshData();
        closeUdateWeekModelName();
        emits('week-model-changed');
      }).catch((error: ApiError) => {
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });
      });
  }
}

const deleteWeekModelName = (indexToRemove: number) => {
   if (props.selectedInstituteId && (props.selectedHealthPro || currentPersonId.value)) {

    const weekModelIdsRequest: WeekModelIdsRequest = {
      weekModelIds: weekModelByNames.value[indexToRemove].weekModels.map((weekModel: WeekModelResponse) => weekModel.weekModelId)
    }
   
    settingsApi.deleteWeekModelByInstitute({instituteId:  props.selectedInstituteId, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value, weekModelIdsRequest: weekModelIdsRequest})
      .then(() => {
        toastSuccess(toast, {
            summary: t('common.toast.success.update'),
            detail:  t('settings.label.weekModel.message.success.update')
        });
        refreshData();
        emits('week-model-changed');
      }).catch((error: ApiError) => {
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });
      });
  }
}

watch(
    () => props.selectedInstituteId,
  () => {
    refreshData();
  }
);

watch(
  () => props.refreshData,
  () => {
    if (props.refreshData === true) {
      refreshData()
    }    
  }
);
watch(
    () => props.selectedHealthPro,
    () => {
      refreshData();
    }
);

watch(
  () => props.isOpen,
  () => {
    if (props.isOpen) {
      refreshData();
    }
  }
)

onMounted(() => {
  refreshData();
});


return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_es_modal_header, {
              "icon-action": 'plus',
              "path-icon-action": 'shareIcons',
              header: _ctx.header,
              "label-button-action": 'settings.label.weekModel.action.add.button',
              onExecuteAction: _cache[0] || (_cache[0] = ($event: any) => (addWeekType()))
            }, null, 8, ["header"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(Accordion), {
                    value: activeIndex.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((activeIndex).value = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekModelByNames.value, ({ name, isStandard, weekModels }, index) => {
                        return (_openBlock(), _createBlock(_unref(AccordionPanel), {
                          key: name,
                          value: index
                        }, {
                          default: _withCtx(() => [
                            (!isStandard && indexToUpdate.value === index)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createVNode(_unref(InputText), {
                                    type: "text",
                                    size: "small",
                                    modelValue: weekModelUpdateNameRequest.value.newName,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((weekModelUpdateNameRequest.value.newName) = $event)),
                                    class: "w-20"
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_es_button_icon, {
                                    icon: "checkmark",
                                    folder: "shareIcons",
                                    class: "pad-l",
                                    styles: "img-primary",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (validUpdateWeekModelName()))
                                  }),
                                  _createVNode(_component_es_button_icon, {
                                    icon: "xmark",
                                    folder: "shareIcons",
                                    class: "pad-l",
                                    styles: "img-grey-dark",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (closeUdateWeekModelName()))
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (indexToUpdate.value !== index)
                              ? (_openBlock(), _createBlock(_unref(AccordionHeader), { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                          _createElementVNode("div", null, _toDisplayString(name), 1),
                                          (!isStandard)
                                            ? (_openBlock(), _createBlock(_component_es_button_icon, {
                                                key: 0,
                                                icon: "pencil_fill",
                                                folder: "shareIcons",
                                                class: "pad-l",
                                                styles: "img-primary",
                                                onClick: ($event: any) => (openUdateWeekModelName(name, weekModels, index))
                                              }, null, 8, ["onClick"]))
                                            : _createCommentVNode("", true),
                                          (!isStandard)
                                            ? (_openBlock(), _createBlock(_component_es_button_icon, {
                                                key: 1,
                                                icon: "trash",
                                                folder: "settings",
                                                class: "pad-l",
                                                styles: "img-red",
                                                onClick: ($event: any) => (deleteWeekModelName(index))
                                              }, null, 8, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            (indexToUpdate.value !== index)
                              ? (_openBlock(), _createBlock(_unref(AccordionContent), {
                                  key: 2,
                                  class: "weekmodel-block bg-clearblue ptop-10"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekModels, (weekItem, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "w-full overflow-hidden"
                                      }, [
                                        _createElementVNode("div", _hoisted_11, [
                                          _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('enum.weekday.' + weekItem.weekday)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_14, [
                                            _createVNode(_unref(Select), {
                                              modelValue: weekItem.dayModel,
                                              "onUpdate:modelValue": ($event: any) => ((weekItem.dayModel) = $event),
                                              options: dayModels.value,
                                              onValueChange: ($event: any) => (changeDayModel($event, weekItem)),
                                              size: "small",
                                              class: "w-full",
                                              optionLabel: "label"
                                            }, _createSlots({ _: 2 }, [
                                              (weekItem.dayModel)
                                                ? {
                                                    name: "value",
                                                    fn: _withCtx((slotProps) => [
                                                      _createElementVNode("div", _hoisted_15, _toDisplayString(slotProps.value.name), 1)
                                                    ]),
                                                    key: "0"
                                                  }
                                                : undefined
                                            ]), 1032, ["modelValue", "onUpdate:modelValue", "options", "onValueChange"])
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ]),
            _createVNode(_component_es_modal_footer, {
              confirmModalMethod: () => confirmFormModal(),
              confirmLabel: 'action.close',
              displayCancel: false
            }, null, 8, ["confirmModalMethod"])
          ], 512)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})